module.exports = __webpack_public_path__ + "media/groups/star-starburst-flash-group-98ac0f9f.svg";